export default {
  anotherOffWhite: "#FAFAFA",
  backgroundGray: "#F5F4F3",
  backgroundGray20: "rgba(245, 244, 243, 0.2)",
  backgroundGray30: "rgba(245, 244, 243, 0.3)",
  backgroundGray40: "rgba(245, 244, 243, 0.4)",
  backgroundGray70: "rgba(245, 244, 243, 0.7)",
  backgroundGrayHover: "#E9E8E7",
  backgroundGrayHover50: "rgba(233, 232, 231, 0.5)",
  backgroundGrayHoverHover: "#EBEAE9",
  black: "#000000",
  black03: "rgba(0, 0, 0, 0.03)",
  black04: "rgba(0, 0, 0, 0.04)",
  black10: "rgba(0, 0, 0, 0.1)",
  black30: "rgba(0, 0, 0, 0.3)",
  black50: "rgba(0, 0, 0, 0.5)",
  borderGray: "#C4C4C4",
  brandGreen: "#0B865A",
  brandHover: "#FF5E5E",
  brandHoverOutline: "#FFE1E1",
  brandMagenta: "#9C3769",
  brandOrange: "#F26722",
  copyrightGray: "#3F4145",
  copyrightGrayHover: "#727478",
  dashGray: "#E5E4E4",
  dealGray: "#FBFAF9",
  disabledGray: "#E3E3E3",
  dividerLineGray: "#F3F2F1",
  errorBackground: "#FF7171",
  errorBackground05: "rgba(255, 113, 113, 0.05)",
  errorBackground10: "rgba(255, 113, 113, 0.10)",
  errorMui: "#D32F2F",
  hoverBlack: "#111111",
  justAnotherGray: "#E8E8E8",
  lightGray: "#EBEAE9",
  mediumDarkGray: "#75787B",
  mediumGray: "#A7ABAA",
  mediumGray10Percent: "rgba(167, 171, 170, 0.1)",
  offBlack: "#292A2D",
  offWhite: "#FFFEFD",
  offWhite40: "rgba(255, 254, 253, 0.4)",
  promoBannerDesktopGraySeriously: "#FCFBFA",
  reflowBlack: "#131314",
  reflowBlackHover: "#1A1A1B",
  reviewGray: "#EEEEEE",
  reviewGrayHover: "#F0F0F0",
  sidebarGray: "#FAF9F8",
  sideBarHeaderGray: "#EDECEB",
  trashBarGray: "#ECEBEA",
  uPromoBannerButtonBackground05: "rgb(252, 251, 250, 0.05)",
  white: "#FFFFFF",
}
